export const STORE_LOGIN_DATA = 'STORE_LOGIN_DATA';
